import { useUI } from "../lib/theme";

type TitleKey = "empty_no_activities" | "empty_no_health" | "empty_no_gear";
type DescKey = "empty_no_activities_desc" | "empty_no_health_desc" | "empty_no_gear_desc";

interface Props {
  title: TitleKey;
  desc: DescKey;
  hasConnections?: boolean;
  onConnect?: () => void;
}

export function EmptyState({ title, desc, hasConnections, onConnect }: Props) {
  const { t } = useUI();
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <WestyMark />
      <div className="space-y-1">
        <p className="text-base font-semibold text-fg">{t(title)}</p>
        <p className="max-w-xs text-sm text-muted">{t(desc)}</p>
      </div>
      {hasConnections === false && onConnect && (
        <button
          onClick={onConnect}
          className="rounded-xl bg-accent px-4 py-2 text-sm font-semibold text-white transition hover:brightness-110"
        >
          {t("empty_cta_connect")}
        </button>
      )}
      {hasConnections === true && (
        <p className="text-xs text-muted">{t("empty_syncing")}</p>
      )}
    </div>
  );
}

function WestyMark() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden>
      <circle cx="24" cy="24" r="24" fill="rgb(var(--panel2))" />
      <circle cx="24" cy="20" r="10" fill="rgb(var(--line))" />
      <circle cx="24" cy="20" r="6" fill="rgb(var(--muted))" opacity="0.4" />
      <circle cx="19" cy="33" r="5" fill="rgb(var(--line))" />
      <circle cx="29" cy="33" r="5" fill="rgb(var(--line))" />
    </svg>
  );
}
